import { render, staticRenderFns } from "./PanelAlert.vue?vue&type=template&id=6090c4a3&scoped=true&"
import script from "./PanelAlert.vue?vue&type=script&lang=js&"
export * from "./PanelAlert.vue?vue&type=script&lang=js&"
import style0 from "./PanelAlert.vue?vue&type=style&index=0&id=6090c4a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6090c4a3",
  null
  
)

export default component.exports